import React from "react";
import styled from 'styled-components';
import { useSelector } from "react-redux";

const IntegrationContent = styled.div`
  padding: 1rem;
  
  button {
    font-size: 13px !important;
  }
  
  h3 {
    font-family: Roboto;
    font-weight: 400;
    font-size: 15px;
    line-height: 22px;
    color: #E5E5E5;
    margin-left: 54px;
  }
`;

const IntegrationItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  padding: 20px 0px;
  margin: 0px;
  cursor: pointer;

  &:hover {
    background: #282828;
  }

  svg {
    font-size: 18px;
  }
`;

const Integration = ({ goToCesiumIonPage, goToWebMapServicePage, goToAPIPage }) => {
  const profile = useSelector(state => state.profile.profile);

  return (
    <IntegrationContent>
      {profile.roles && profile.roles[0] && (profile.roles[0].name == 'Admin' || profile.roles[0].name == 'Manager') ?
      <IntegrationItem onClick={goToCesiumIonPage}>
        <h3>Cesium Ion</h3>
      </IntegrationItem>
      : 
      null}
      <IntegrationItem onClick={goToWebMapServicePage}>
        <h3>Web Map Service</h3>
      </IntegrationItem>
      <IntegrationItem onClick={goToAPIPage}>
        <h3>FastMap API Key</h3>
      </IntegrationItem>
    </IntegrationContent>
  );
};

export default Integration;